module.exports = __webpack_public_path__ + "static/img/59.1cb4f698.gif";